export const borderWidth = {
  0: "0px",
  1: "1px",
  2: "2px",
  3: "3px",
  4: "4px",
  6: "6px",
  8: "8px"
};
